<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Soubory - Kategorie - Upravit <span class="utils__link--underlined text-primary">#{{ this.id }}</span></strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <a-form :form="form" @submit="handleSubmit">

        <a-form-item
          label="Název"
          :validate-status="error('fcy_name') ? 'error' : ''"
          :help="error('fcy_name') || ''"
        >
          <a-input
            v-decorator="[`fcy_name`, {rules: [{max: 80, message: 'Název nemůže být delší než 80 znaků!'}, {required: true, message: 'Název musí být vyplněna!'}]}]"
            placeholder="Název"
          />
        </a-form-item>

        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '../../../../services/forms'

export default {
  components: { ActionTools },
  data: function () {
    return {
      hasErrors,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/file/category',
          title: 'Seznam',
        },
      ],
      form: this.$form.createForm(this),
      id: this.$route.params.id,
    }
  },
  computed: {
    detail: function () {
      return this.$store.getters['fileCategory/getDetail']
    },
  },
  methods: {
    refreshComponent(id) {
      this.id = id
    },
    getData() {
      return {
        fcy_name: this.form.getFieldValue('fcy_name'),
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('fileCategory/put', { id: this.id, item: this.getData() })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    initDetail() {
      this.loading = true
      this.$store.dispatch('fileCategory/getOne', this.id)
        .then(() => {
          this.form.setFieldsValue({
            fcy_name: this.detail.fcy_name,
          })
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
  },
  created() {
    this.initDetail()
  },
  watch: {
    '$route.params.id'(newId, oldId) {
      this.refreshComponent(newId)
      this.initDetail()
    },
  },
}
</script>

<style lang="scss" module>
  @import "./style.module.scss";
</style>
